import { useCurrencySelector } from "@appsinti/currency-provider";
import { PRIMARY } from "@etiquette-ui/colors";
import React, { useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CurrencySelect = styled.button`
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  border: none;
  background: none;
  cursor: pointer;
  color: ${PRIMARY};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const CurrencyOptionsContainer = styled.div`
  position: absolute;
  top: 25px;
  display: flex;
  justify-content: center;
  z-index: 5;
  width: max-content;
`;

const CurrencyOptionsBackground = styled.div`
  background: white;
  padding: 4px;
  border-radius: 5px;
  box-shadow: 0px 8px 24px #0332693d;
  display: flex;
  flex-direction: column;
  gap: 5px;

  span {
    padding: 4px 10px;
    border-radius: 5px;
    &.selected {
      background: ${PRIMARY};
      color: white;
    }
  }
`;

const CurrencyOptions: React.FC<{}> = () => {
  const [currencyOpen, setCurrencyOpen] = useState<boolean>(false);
  const {
    currency,
    setCurrency,
    supportedCurrencies,
    currencyEnabled,
  } = useCurrencySelector();

  const toggleCurrency = () => {
    setCurrencyOpen(!currencyOpen);
  };

  const onSelectCurrency = (c: string | null) => {
    setCurrency(c);
    setCurrencyOpen(false);
  };

  return (
    <>
      <Container>
        {currencyEnabled && (
          <CurrencySelect onClick={toggleCurrency}>
            {currency === null ? "NO FX" : currency}
            {currencyOpen && (
              <CurrencyOptionsContainer>
                <CurrencyOptionsBackground>
                  <span
                    className={null === currency ? "selected" : ""}
                    onClick={() => onSelectCurrency(null)}
                  >
                    NO FX
                  </span>
                  {supportedCurrencies.map((c, index) => (
                    <React.Fragment key={c}>
                      <span
                        className={c === currency ? "selected" : ""}
                        onClick={() => onSelectCurrency(c)}
                      >
                        {c}
                      </span>
                    </React.Fragment>
                  ))}
                </CurrencyOptionsBackground>
              </CurrencyOptionsContainer>
            )}
          </CurrencySelect>
        )}
      </Container>
    </>
  );
};

export default CurrencyOptions;